import React from 'react';
import { Star, MapPin } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VenueCard({ venue, onClick }) {
  return (
    <button
      onClick={onClick} data-testid={`explore-venue-card-${venue.id}`}
      className="group overflow-hidden rounded-2xl border border-white/10 bg-[#1E2D4A] text-right transition-transform hover:-translate-y-1 hover:border-teal-400/40"
    >
      <div className="h-36 w-full overflow-hidden bg-white/5">
        {venue.has_image ? (
          <img src={`${API}/venues/${venue.id}/image`} alt={venue.name} className="h-full w-full object-cover transition-transform group-hover:scale-105" />
        ) : (
          <div className="flex h-full items-center justify-center text-slate-500">لا توجد صورة</div>
        )}
      </div>
      <div className="p-4">
        <h4 className="font-bold text-white" data-testid={`explore-venue-name-${venue.id}`}>{venue.name}</h4>
        <p className="mt-0.5 flex items-center gap-1 text-xs text-slate-400">
          <MapPin className="h-3 w-3" /> {venue.club_name}{venue.city ? ` — ${venue.city}` : ''}
        </p>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {venue.sport_type && <span className="rounded-full bg-teal-400/15 px-2 py-0.5 text-[10px] font-semibold text-teal-300">{venue.sport_type}</span>}
          {venue.dimensions && <span className="rounded-full bg-white/10 px-2 py-0.5 text-[10px] font-semibold text-slate-200">{venue.dimensions}</span>}
          {venue.capacity && <span className="rounded-full bg-white/10 px-2 py-0.5 text-[10px] font-semibold text-slate-200">سعة {venue.capacity}</span>}
          {venue.women_friendly === true && <span className="rounded-full bg-pink-500/20 px-2 py-0.5 text-[10px] font-semibold text-pink-300">للسيدات</span>}
        </div>
        <div className="mt-3 flex items-center justify-between">
          <span className="text-sm font-bold text-teal-300">{venue.price_per_hour ? `${venue.price_per_hour} ر.س/ساعة` : 'السعر عند التواصل'}</span>
          <span className="flex items-center gap-1 text-xs text-slate-400">
            <Star className={`h-3.5 w-3.5 ${venue.rating_avg ? 'fill-amber-400 text-amber-400' : 'text-slate-600'}`} />
            {venue.rating_avg ? `${venue.rating_avg} (${venue.review_count})` : 'جديد'}
          </span>
        </div>
      </div>
    </button>
  );
}
